import reusables from '@styles/theme/reusables';
import theme from '@styles/theme';
export default {
  voxContainer: {
    width: '100%',
    textAlign: 'center',
    m: '0 auto',
    p: 0
  },
  mainContainer: {
    overflowX: 'scroll',
    whiteSpace: 'nowrap',
    '::-webkit-scrollbar': {
      display: 'none'
    },
    scrollbarColor: 'transparent transparent'
  },
  groupName: {
    fontSize: ['14px', '14px', '16px'],
    display: 'inline-block',
    m: '12px auto 0 auto',
    textAlign: 'center',
    color: theme.rawColors.neutralBlack
  },
  groupThumbnailContainer: {
    height: 'auto',
    minWidth: ['52px', '52px', '52px', '80px'],
    width: ['52px', '52px', '52px', '80px'],
    m: '0 auto'
  },
  groupLink: {
    cursor: 'pointer',
    textAlign: 'center',
    m: '0 16px',
    display: 'inline-block',
    position: 'relative',
    minWidth: ['90px', '122px'],
    mb: '32px',
    color: theme.rawColors.neutralBlack,
    ':before': {
      content: '""',
      position: 'absolute',
      left: '50%',
      bottom: '-14px',
      transform: 'translateX(-50%)',
      width: '100%',
      opacity: 0,
      height: '2px',
      color: theme.rawColors.neutralBlack,
      background: theme.rawColors.neutralBlack,
      ...reusables.mainTransition('opacity', 'ease-in-out')
    },
    ':hover': {
      ':before': {
        opacity: 1
      }
    }
  }
};